import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Lookup,
    Export,
    HeaderFilter
} from 'devextreme-react/data-grid';

import DataSource from 'devextreme/data/data_source';
import LoadIndicator from 'devextreme-react/load-indicator';
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import { Link, useNavigate } from 'react-router-dom';
import TabPanel, { Item } from "devextreme-react/tab-panel";
import axios from 'axios';
import { backendlink } from '../../config';

// import Timeline from 'wavesurfer.js/dist/plugins/timeline.esm.js'
import WaveSurfer from 'wavesurfer.js'
import TimelinePlugin from 'wavesurfer.js/dist/plugins/timeline.esm.js'


// import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions.esm.js'

// import WaveSurfer from 'https://unpkg.com/wavesurfer.js@7/dist/wavesurfer.esm.js'

export default function DoctorPatientOtherMessageDatagrid() {

    const { user } = useAuth();

    const navigate = useNavigate();

    const [patientToken, setPatientToken] = useState("")

    const location = useLocation();

    const [linkedCustomerName, setLinkedCustomerName] = useState('');
    const [linkedCustomerID, setLinkedCustomerID] = useState('');
    const [linkedDoctorName, setLinkedDoctorName] = useState('');
    const [patientName, setPatientName] = useState('');

    const [waveform, setWaveform] = useState([]);
    const [waveformIsOn, setWaveformIsOn] = useState([]);

    const initalPageSize = 5;
    const initalPageIndex = 0;

    const fetchData = async () => {
        try {
            const response = await axios.post(backendlink + 'doctor/getpatient',
                {
                    doctortoken: user.userToken,
                    patienttoken: location.state.patientToken
                },
                {
                    headers: {
                        token: user.token
                    }
                });

            if (response.data.errorno == 0) {
                const outputArray = response.data.result.map(item => {

                    setLinkedCustomerName(item.linkedcustomer)
                    setLinkedCustomerID(item.linkedcustomerid)
                    setLinkedDoctorName(item.linkeddoctor)
                    setPatientName(item.name)

                    fetchMessage({ skip: initalPageIndex, take: initalPageSize });
                });
            } else {
                alert(response.data.errmessage);
            }
        } catch (error) {
            alert(error);
        }
    };

    const fetchMessage = async (loadOptions) => {
        try {
            const page = Math.floor(loadOptions.skip / loadOptions.take) + 1;
            const size = loadOptions.take;

            let sortStr = "recordTime:desc";//default sort by recordTime desc
            if(loadOptions.sort){
                sortStr = loadOptions.sort[0].selector;
                if(sortStr == "recordDate"){
                    sortStr = "recordTime";
                }else if(sortStr == "sharedDate"){
                    sortStr = "sharedAt";
                }
                if (loadOptions.sort[0].desc) {
                    sortStr += ":desc";
                }else{
                    sortStr += ":asc";
                }
            }
            console.log("Load Options:", loadOptions);

            let postData = {
                userToken: user.userToken,
                patientToken: location.state.patientToken,
                page: page,
                size: size
            };
            if( sortStr.length > 0){
                postData.sorts = sortStr;
            }

            const response = await axios.post(backendlink + 'doctor/getotherpatientlogs',
                postData,
                {
                    headers: {
                        token: user.token
                    }
                });

            if (response.data.errorno == 0) {
                const outputArray = response.data.result.map(item => {
                    let detailsString = "";
                    // if(item.classifyResult == 0){
                    //     detailsString = "Normal";
                    // }else{
                    //     detailsString = '<span style="color: #BA1A1A;">Abnormal</span>';
                    // }
                    // detailsString += "<br/>" + item.bpmResult+" BPM";
                    // if (item.labelid != '') {
                    //     detailsString += "<br/>" +item.labelid+" position";
                    // }
                                        
                    return { 
                        uid: item.uid,
                        labelid: item.labelid,
                        sharedDate: item.sharedDate,
                        recordDate: item.recordDate,
                        details: detailsString 
                    };
                });

                // Update the total records count for pagination
                //setTotalRecords(response.data.meta.total);
                //outputArray.sort((a, b) => new Date(b.sharedDate) - new Date(a.sharedDate));
                return {
                    data: outputArray, // Data for the current page
                    totalCount: response.data.meta.total, // Total number of records
                };
                //setMessages(outputArray)
            } else {
                alert(response.data.errmessage);
            }
        } catch (error) {
            alert(error);
        }
    }
    const [dataSource] = useState(new DataSource({
        load: fetchMessage,
    }));
    function gridOnOptionChanged(e) {
        if (e.name == 'paging' || e.name == 'columns') {
            setWaveform([])
            setWaveformIsOn([])
        }
    }

    function getWaveformData(uid) {
        const handleClick = (e) => {
            e.preventDefault();

            const fetchWaveformData = async () => {
                if (waveformIsOn[uid] === undefined || waveformIsOn[uid] === null || waveformIsOn[uid] == false) {
                    setWaveformIsOn({ ...waveformIsOn, [uid]: true });
                    try {
                        const response = await axios.post(backendlink + 'doctor/getmedicalrecord',
                            {
                                auscultationid: uid,
                                patienttoken: location.state.patientToken,
                                analysisType: "lung"
                            },
                            {
                                headers: {
                                    token: user.token
                                }
                            });
                        if (response.data.errorno == 0) {
                            const temp = "data:audio/wav;base64," + response.data.result.audioFile;
                            setWaveform({ ...waveform, [uid]: temp });

                            const audioElement = document.createElement('audio');
                            audioElement.controls = true;
                            audioElement.controlsList = 'noplaybackrate nodownload';
                            audioElement.style.width = "100%";
                            audioElement.src = temp;
                            
                            // Append the WaveSurfer container first
                            const container = document.getElementById('waveform-' + uid);
                            const waveformContainer = document.createElement('div');
                            waveformContainer.id = 'waveform-container-' + uid;
                            container.appendChild(waveformContainer);
                            
                            // Append the audio element to the container
                            container.appendChild(audioElement);
                            
                            const ws = WaveSurfer.create({
                                container: '#waveform-container-' + uid,
                                height: 100,
                                cursorWidth: 1,
                                waveColor: '#001B3F',
                                cursorColor: '#001B3F',
                                progressColor: '#E0E2ED',
                                normalize: true,
                                media: audioElement, // Pass the custom audio element
                                plugins: [TimelinePlugin.create({
                                    container: '#waveform-container-' + uid , // Ensure the timeline plugin uses the correct container
                                    timeInterval: 0.1,
                                    primaryLabelInterval: 5,
                                    secondaryLabelInterval: 1,
                                })],
                            });
                            
                            // Create a div for the timeline plugin
                            const timelineContainer = document.createElement('div');
                            waveformContainer.appendChild(timelineContainer);
                            
                            ws.on('click', () => {
                                ws.play()
                            })
                        } else {
                            alert(response.data.errmessage)
                        }
                    } catch (error) {
                        alert(error);
                    }
                }
            };
            fetchWaveformData();
        }

        return (
            <button onClick={handleClick} style={{ backgroundColor: '#005CBB', color: 'white', padding: '10px 20px', borderRadius: '5px', border: "none", marginBottom: "10px", cursor: 'pointer' }}>
                Lung Sound
            </button>
        );
    }

    const waveformCell = (cellData) => (
        <div>
            {getWaveformData(cellData.data.uid)}
            <br />
            {/* {waveform[cellData.data.uid] 
            && <audio controls style={{ width: "100%" }} controlsList="noplaybackrate nodownload">
                <source src={waveform[cellData.data.uid]} type="audio/mpeg" />
                Your browser does not support the audio element.
            </audio>
            } */}
        </div>
    );

    const DataRow = (rowInfo) => (
        <React.Fragment>
            <tr role="row" >
                <td role="gridcell" style={{ paddingLeft: '16px', paddingRight: '16px' }}>{rowInfo.data.sharedDate}</td>
                <td role="gridcell" style={{ paddingLeft: '16px', paddingRight: '16px' }}>{rowInfo.data.recordDate}</td>
                <td role="gridcell" style={{ paddingLeft: '16px', paddingRight: '16px' }}>{React.createElement("div", { dangerouslySetInnerHTML: { __html: rowInfo.data.details } })}</td>
                {/* <td role="gridcell">{rowInfo.data.labelid}</td> */}
                <td role="gridcell" style={{ paddingLeft: '16px', paddingRight: '16px' }}>{waveformCell(rowInfo)}</td>
            </tr>
            <tr className="waveform-row">
                <td colSpan={6}>
                    <div id={"waveform-" + rowInfo.data.uid} />
                </td>
            </tr>
        </React.Fragment>
    );

    useEffect(() => {
        if (location.state?.patientToken == null) {
            navigate('/');
        } else {
            setPatientToken(location.state.patientToken);
            fetchData();
        }
    }, [user]);

    return (
        <React.Fragment>
            <table className="custom-table">
                <thead>
                    <tr>
                        <th>Organization:</th>
                        <td>{linkedCustomerName}</td>
                        <th>Organization ID:</th>
                        <td>{linkedCustomerID}</td>
                        <th>Doctor:</th>
                        <td>{linkedDoctorName}</td>
                        <th>Patient:</th>
                        <td>{patientName}</td>
                    </tr>
                </thead>
            </table>

            <DataGrid 
                dataSource={dataSource} 
                dataRowRender={DataRow} 
                cacheEnabled={false}
                remoteOperations={true}
                onOptionChanged={gridOnOptionChanged} 
            >
                <Column dataField="sharedDate" caption='Shared Date' width="20%" />
                <Column dataField="recordDate" caption='Record Date' width="20%" />
                <Column dataField="details" caption='Details' width="30%" allowSorting={false} />
                {/* <Column dataField='logTime' caption="Patient's Note" width="10%" allowSorting={false} /> */}
                <Column dataField="waveform" caption='Waveform' minWidth="320" width="30%" allowSorting={false} />
                <Pager allowedPageSizes={[5, 10]} showPageSizeSelector={true} />
                <Paging
                    defaultPageSize={initalPageSize}
                    defaultPageIndex={initalPageIndex}
                />
                {/* <FilterRow visible={true} /> */}
                <Lookup />
                {/* <Export enabled={true} /> */}
                {/* <HeaderFilter visible={true} /> */}
            </DataGrid>
        </React.Fragment>
    )
}